<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="false" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.newRecord.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          input(type="file" id="file" ref="file" v-on:change="handleFileUpload()" accept="application/pdf")
          vm-col(vm-justify="center", vm-align="center", vm-w=12)
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:label='$t("submittals.created_by")', v-model='newRecord.creator' :danger="$v.newRecord.creator.$invalid && $v.newRecord.creator.$model" :placeholder='$t("submittals.created_by_placeholder")')
            vm-select-item(:value='1', text='Cano')
            vm-select-item(:value='2', text='Customer')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("submittals.comments_placeholder")' v-model="newRecord.comments" :label='$t("submittals.comments")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(
            style="width: 100%",
            :label="$t('projects.date')",
            v-model="newRecord.date"
          )
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('SubmittalDetails')

export default {
  name: 'ModalSubmittalDetails',
  props: {
    newRecord: {
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    },
    submittal: {
      default: null,
      type: Number
    }
  },
  validations () {
    return {
      newRecord: {
        date: {
          required
        },
        creator: {
          required
        },
        comments: {
          required
        },
        file: {
          required: requiredIf(function () { return this.fileValidate })
        }
      }
    }
  },
  data: () => ({
    file: ''
  }),
  computed: {
    ...mapGetters([
      'isModalVisible',
      'quotationFilesCatalog'
    ]),
    fileValidate () {
      return this.file.length < 1
    },
    getTitle () {
      return this.isAdd ? this.$t('strings.add') : this.$t('strings.edit')
    }
  },
  methods: {
    ...mapActions([
      'addSubmittalDetail',
      'editSubmittalDetail',
      'deleteSubmittalDetail',
      'setModalVisible',
      'loadCatalog'
    ]),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    saveRecord () {
      this.addSubmittalDetail({ file: this.file, newRecord: this.newRecord, submittal_id: this.submittal })
      this.file = ''
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>
